<div class="topline">
  <h2>Brand Domains</h2>
  <div class="actions">
    <button mat-raised-button color="primary" (click)="addBrandDomain()">Add Domain</button>
  </div>
</div>

<div class="target-controls" *ngIf="supportsTargetSelection">
  <mat-tab-group class="target-tabs" [selectedIndex]="selectedTabIndex" (selectedIndexChange)="onTargetTabChange($event)">
    <mat-tab label="QA" [disabled]="isDemoEnv"></mat-tab>
    <mat-tab label="Demo"></mat-tab>
  </mat-tab-group>
  <div class="target-meta">
    <mat-chip-set>
      <mat-chip color="primary" selected>Target: {{activeTargetLabel}}</mat-chip>
    </mat-chip-set>
    <div class="target-help" *ngIf="isDemoEnv">QA target management is only available in QA environment.</div>
  </div>
</div>

<div class="scroll-container">
  <table mat-table [dataSource]="domainList" class="table">
    <ng-container matColumnDef="domain">
      <th mat-header-cell *matHeaderCellDef>Domain</th>
      <td mat-cell *matCellDef="let domain">{{domain.domain}}</td>
    </ng-container>

    <ng-container matColumnDef="provider">
      <th mat-header-cell *matHeaderCellDef>Provider</th>
      <td mat-cell *matCellDef="let domain">{{domain.provider.join(', ')}}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let domain">
        <button mat-icon-button [matMenuTriggerFor]="actionsMenu" [matMenuTriggerData]="{domain: domain}">
          <mat-icon>more_vert</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['domain','provider','actions']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['domain','provider','actions']"></tr>
  </table>

  <div class="loading" *ngIf="loading">Loading...</div>
  <div class="empty" *ngIf="!loading && domainList.length === 0">{{emptyMessage}}</div>
</div>

<mat-menu #actionsMenu="matMenu">
  <ng-template matMenuContent let-domain="domain">
    <button mat-menu-item (click)="deleteDomain(domain.domain)">Delete</button>
  </ng-template>
</mat-menu>
